import { api } from './api'
import { useMutation, useQuery } from 'react-query'

const LOG_KEY = 'log'
const IMAGE_TEST_KEY = 'testlist'

const fetchLog = (data) => {
  return api.post({ path: `${LOG_KEY}`, data })
}

const getImageTest = () => {
  return api.get({ path: `public/file/${IMAGE_TEST_KEY}` })
}

export function useMutateLog () {
  return useMutation(fetchLog)
}

export function useImageTestQuery (options) {
  return useQuery([IMAGE_TEST_KEY], getImageTest, options)
}
